import { ReactNode } from 'react';

import {
  ChartTooltipElementProps,
  ChartTooltipTimestampHeader,
  DataPopperRow,
  Typography,
} from '@cast/design-system';
import { toNumOrZero } from '@cast/utils';

import { DataTransferChartDatapoint } from 'features/cost-report/types/networkCostOverTime';
import { TimeSeriesEntry } from 'types/metrics';

type ChartDataItem = TimeSeriesEntry<DataTransferChartDatapoint>;

type MakeNetworkChartTooltipArgs = {
  label: string;
  timezone: string;
  getValue: (data: ChartDataItem) => number;
  formatValue: (value: number) => ReactNode;
};

export const makeNetworkChartTooltip = ({
  label,
  timezone,
  getValue,
  formatValue,
}: MakeNetworkChartTooltipArgs) => {
  const tooltipHeader = ({
    data,
    testId,
  }: ChartTooltipElementProps<ChartDataItem>) => (
    <>
      <ChartTooltipTimestampHeader
        data={data}
        timezone={timezone}
        testId={testId}
      />
      <DataPopperRow
        dividerBottom
        left={<Typography variant="L10M">{label}</Typography>}
        right={
          <Typography variant="P10M">{formatValue(getValue(data))}</Typography>
        }
      />
    </>
  );

  const tooltipFormatValue = (value: string | number | undefined) =>
    formatValue(toNumOrZero(value));

  return { tooltipHeader, tooltipFormatValue };
};
